import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getGeoCoordinates, getNewbuildingId } from '../../../selectors/newbuilding';
import { useApplicationContext } from '../../../utils/withApplicationContext';

export function useMapPreviewUrl() {
  const { config, telemetry } = useApplicationContext();
  const newbuildingId = useSelector(getNewbuildingId);
  const coordinates = useSelector(getGeoCoordinates);

  const mapPreviewUrl = useMemo(() => {
    const mapPreviewTemplate = config.get<string>('audience.mapPreviewTemplate');

    if (!coordinates || !mapPreviewTemplate) {
      return null;
    }

    const params: Record<string, number> = { ...coordinates, id: newbuildingId };

    return mapPreviewTemplate.replace(/{{(lat|lng|id)}}/g, (_, matched: string) => `${params[matched]}`);
  }, [config, coordinates, newbuildingId]);

  /* istanbul ignore next */
  useEffect(() => {
    if (!mapPreviewUrl) {
      return;
    }

    telemetry.increment('static-maps.request');

    const image = new Image();

    image.src = mapPreviewUrl;

    image.onerror = () => {
      telemetry.increment('static-maps.error');
    };
  }, [mapPreviewUrl, telemetry]);

  return mapPreviewUrl;
}
